// extracted by mini-css-extract-plugin
export default {"block":"Ve","select":"We","empty":"Xe","open":"Ye","error":"Ze","options":"_e","selectActive":"af","ornament":"bf"};